angular.module('impactx.controlstructure').controller('CRDCtrl', [
    '$scope',
    '$controller',
    'ToolbarService',
    CRDCtrl
]);

function CRDCtrl($scope, $controller, ToolbarService) {
    var self = this;
    angular.extend(self, $controller('ControlStructureCtrl', {$scope: $scope}));

    $scope.endPointView = "/control/crd/view";
    $scope.endPointSave = "/control/crd/save";
    $scope.endPointDelete = "/control/crd/delete";

    $scope.getPageData().then(function () {
        defineButtons();
    });

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: $scope.savePageData,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.delete,
                action: $scope.delete,
                type: 'dialogaction',
                condition: canDelete
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.crd.readOnly;
    }

    function canDelete() {
        return $scope.id > 0 && !$scope.data.crd.readOnly && !$scope.data.crd.deprecated;
    }
}